import React from "react";

import { useSelector } from "react-redux";

import { getFullState } from "store/features/Auth/auth.slice";

import usePermissions from "./usePermissions";

type CheckPermissionsType = {
	path?: string;
};
const CheckPermissions: React.FC<CheckPermissionsType> = ({ children, path }) => {
	const { accessPerRoute } = useSelector(getFullState);
	const accessPerCustomRoute = usePermissions(path);

	const { canEdit, canView } = path ? accessPerCustomRoute : accessPerRoute;

	return React.cloneElement(canView ? children : <></>, { disabled: !canEdit });
};

export default CheckPermissions;
